import React from "react";
import { createPortal } from "react-dom";

const MENU_WIDTH = 190;
const MENU_ITEM_HEIGHT = 40;
const MENU_ITEMS = 2;
const MENU_HEIGHT = MENU_ITEM_HEIGHT * MENU_ITEMS + 16;

const menuItemStyle = {
  padding: "9px 16px",
  fontSize: "13px",
  color: "#444",
  cursor: "pointer",
  transition: "background-color 0.15s ease",
};

const InactivePatientActionsDropdown = ({
  openDropdownId,
  dropdownPos,
  patients,
  onAction,
}) => {
  if (!openDropdownId) return null;

  const patient = patients.find((p) => p.id === openDropdownId);
  if (!patient) return null;

  const handleItemClick = (action) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    onAction(action, patient);
  };

  return createPortal(
    <ul
      role="menu"
      aria-label="Inactive patient actions"
      className="patient-actions-menu"
      onMouseDown={(e) => e.stopPropagation()}
      style={{
        position: "fixed",
        top: dropdownPos.top,
        left: dropdownPos.left,
        backgroundColor: "#ffffff",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0px 4px 16px rgba(0,0,0,0.12)",
        padding: "6px 0",
        margin: 0,
        listStyle: "none",
        zIndex: 99999,
        minWidth: `${MENU_WIDTH}px`,
        maxWidth: "min(90vw, 220px)",
      }}
    >
      <li
        role="menuitem"
        tabIndex={0}
        onClick={handleItemClick("view")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleItemClick("view")(e);
        }}
        style={{
          ...menuItemStyle,
          color: "#27B99A",
          fontWeight: "600",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#E7F3FF";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
        }}
      >
        View Patient
      </li>

      <li
        role="menuitem"
        tabIndex={0}
        onClick={handleItemClick("reactivate")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ")
            handleItemClick("reactivate")(e);
        }}
        style={{
          ...menuItemStyle,
          color: "#27B99A",
          borderTop: "1px solid #f0f0f0",
          marginTop: "4px",
          fontWeight: "600",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#E7F3FF";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
        }}
      >
        Reactivate Patient
      </li>
    </ul>,
    document.body,
  );
};

export { MENU_WIDTH, MENU_HEIGHT };
export default InactivePatientActionsDropdown;
